<template>
  <Layout ref="main">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-title p-3 py-2 border-bottom">
            <div class="d-lg-flex align-items-center">
              <div class="d-flex align-items-center mb-2 mb-lg-0">
                <div class="me-2">
                  <i class="bi bi-file-earmark-text display-6 text-primary"></i>
                </div>
                <div class="">
                  <h4 class="fw-medium font-size-20 text-dark mb-0">
                    {{ title }}
                  </h4>
                </div>
              </div>
              <!-- <div class="ms-auto">
                  <a :href="`skype:${skype_id}?chat`" class="btn btn-info">
                  <i class="uil uil-skype-alt"></i> Support on Skype</a>
              </div> -->
            </div>
            
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-muted">
                <h4>Overview</h4>
                <p>The Weather API provides real-time weather data for a given location. Developers can integrate this API into their applications to retrieve current weather conditions, forecasts, and other related information.</p>

                <h4>Base URL</h4>
                <code>https://api.weather.com/v1/</code>

                <h4 class="mt-3">Authentication</h4>
                <p>All requests to the Weather API must include an API key for authentication. You can obtain an API key by signing up on the developer portal.</p>

                <h4>Endpoints</h4>

                <h4>1. Current Weather</h4>
                <p><strong>Endpoint:</strong> <code>/current</code></p>
                <p><strong>Parameters:</strong></p>
                <ul>
                    <li>latitude (required): The latitude of the location.</li>
                    <li>longitude (required): The longitude of the location.</li>
                    <li>units (optional): Specify the units for temperature (e.g., metric for Celsius, imperial for Fahrenheit).</li>
                </ul>
                <p><strong>Example Request:</strong></p>
                <pre><code class="bash">GET https://api.weather.com/v1/current?latitude=37.7749&amp;longitude=-122.4194&amp;units=metric&amp;apikey=your_api_key</code></pre>
                <p><strong>Example Response:</strong></p>
                <pre><code class="json">{
    "temperature": 22.5,
    "humidity": 60,
    "conditions": "Clear",
    "wind_speed": 5.3
  }</code></pre>

                <h4>2. Forecast</h4>
                <p><strong>Endpoint:</strong> <code>/forecast</code></p>
                <p><strong>Parameters:</strong></p>
                <ul>
                    <li>latitude (required): The latitude of the location.</li>
                    <li>longitude (required): The longitude of the location.</li>
                    <li>days (optional): Number of days for the forecast (default is 5).</li>
                </ul>
                <p><strong>Example Request:</strong></p>
                <pre><code class="bash">GET https://api.weather.com/v1/forecast?latitude=37.7749&amp;longitude=-122.4194&amp;days=3&amp;apikey=your_api_key</code></pre>
                <p><strong>Example Response:</strong></p>
                <pre><code class="json">{
  "days": [
    {
      "date": "2023-12-16",
      "temperature_max": 24,
      "temperature_min": 18,
      "conditions": "Partly Cloudy"
    },
    // Additional forecast days...
  ]
}</code></pre>

                <h4>Error Handling</h4>
                <p>In case of errors, the API will return an appropriate HTTP status code along with a JSON error object containing details about the issue.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lottie :path="''" :title="'Loading'" :info="'Please wait...'" :show="showLottie" ref="lottieFunc" />
    <Common ref="commonFunc"/>
  </Layout>
</template>
<script>

import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Lottie from "@/components/lottieView";
import Common from "@/components/common";
import axios from "axios";
import Swal from "sweetalert2";
import { 
  required, 
  //minLength,
  //sameAs, 
  //helpers 
} from "vuelidate/lib/validators";
  //const alpha = helpers.regex("alpha", /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/);
/**
 * Technical Information 
 */
 const PageTitle = "Technical Information"

export default {
  components: { 
    Layout, 
    PageHeader, 
    Lottie,
    Common
  },
  page() {
    return {
      title: PageTitle,
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    }
  },
  data() {
    return {
      accessToken:'',
      accessEmail:'',
      accessPhone:'',
      accessUsername:'',
      showLottie:false,
      title: '',
      items: [
        {
          text: appConfig.pageTitle,
          to: "/",
        },
        {
          text: '',
          active: true,
        },
      ],
      username: "",
      merchant_code: "",
      merchant_key: "",
      account_type:"",
      code_for_support_skype:"",
      formData: {
        name:""
      },
      submitted:false,
      loading:false,
      buttonLoading:[false,false,false],
      deleteLoading:false,
      create_modify_permission:false,
      skype_id:"",
      telegram_id:""
    };
  },
  validations: {
    formData: {
      name: {
        required,
      }
    },
  },
  middleware: "authentication",
  async mounted(){
   
    this.title = PageTitle
    this.items[1].text = PageTitle
    // this.$refs.main.changeVerticalTopBar("",true) *first value is back link and second is want set bg color?
    // this.$refs.main.changeVerticalTopBar("bill",true)
    // this.$refs.main.setShowFooterCert(false)
    // this.$refs.main.setPageTitle('title')
    await this.reload()
    this.accessToken = this.$refs.commonFunc.getToken()
    this.accessUsername = this.$refs.commonFunc.getUsername()
    
  }, 
  created(){
   
  },
  methods:{
      async getData(){
        this.$Progress.start();
        this.loading = true;
        var bodyFormData = new FormData();
        bodyFormData.append("accessToken", this.accessToken);
        bodyFormData.append("accessUsername",  this.accessUsername);
        axios({
            method: "post",
            url: appConfig.DemoAPI,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response)=>{
            var resData = response.data;
            if (resData.status == 200) {
              console.log(resData)
            } 
            else if (resData.status == 440){
              Swal.fire(
                  {
                  icon: 'error',
                  title: 'Oops...',
                  html: `${resData.message}.`,
                  confirmButtonColor: '#222',
                  confirmButtonText: this.$t('siteLang.Done'),
                })
                localStorage.clear();
                this.$router.push({
                    path: "/login",
              });
            }
            else {
                Swal.fire(
                  {
                  icon: 'error',
                  title: 'Oops...',
                  html: `${resData.message}.`,
                  confirmButtonColor: '#222',
                  confirmButtonText: this.$t('siteLang.Done'),
                })
            }
            this.loading = false;
            this.$Progress.finish();
        })
        .catch((error)=> {
            this.loading = false;
            this.$Progress.finish();
            console.log(error);
        });
      },
      submit(){
        this.loading = true
        this.$v.formData.$touch();
        console.log((this.$v.formData.$invalid))
        if (this.$v.formData.$invalid) {
          return;
        } else {
          this.$Progress.start();
          this.loading = true;
          var bodyFormData = new FormData();
          bodyFormData.append("accessToken", this.accessToken);
          bodyFormData.append("accessUsername", this.accessUsername);
          bodyFormData.append("name", this.formData.name);
          axios({
              method: "post",
              url:  appConfig.DemoAPI,
              data: bodyFormData,
              headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response)=>{
              
              var resData = response.data;
              if (resData.status == 200) {
                console.log(resData)
                Swal.fire({
                  icon: 'success',
                  title: 'xxxx Updated',
                  html: 'xxxx has been successfully updated!',
                  confirmButtonColor: '#FA6541',
                  confirmButtonText: this.$t('siteLang.Done')
                }).then(() => {
                  console.log("success")
                  this.getData()
                })
                
              } 
              else if (resData.status == 440){
                Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
                  localStorage.clear();
                  this.$router.push({
                      path: "/login",
                });
              }
              else {
                  Swal.fire(
                    {
                    icon: 'error',
                    title: 'Oops...',
                    html: `${resData.message}.`,
                    confirmButtonColor: '#222',
                    confirmButtonText: this.$t('siteLang.Done'),
                  })
              }
              this.loading = false;
              this.submitted = false
              this.$Progress.finish();
            })
            .catch((error)=> {
                this.loading = false;
                this.submitted = false
                this.$Progress.finish();
                console.log(error);
        });
      }
    },
    async reload() {
      try {
        await this.$nextTick(); // Wait for the component to be fully mounted

        const commonFunc = this.$refs.commonFunc;
        if (commonFunc && commonFunc.getFullData) {
          const data = await commonFunc.getFullData();
          this.account_type = data.account_type;
          this.username = data.username;
          this.merchant_key = data.merchant_info.merchant_key;
          this.merchant_code = data.merchant_info.merchant_code;
          if (this.account_type=='reseller'){
            this.code_for_support_skype = data.reseller_info.reseller_code
          }
          else if (this.account_type=='merchant'){
            this.code_for_support_skype = data.merchant_info.merchant_code;
          }
          else{
            this.code_for_support_skype = ''
          }
          this.skype_id = data.skype_id;
          this.telegram_id = data.telegram_id;
          this.formData.name = data.name;
        } else {
          // Handle the case when commonFunc or getFullData is undefined
          // Perform appropriate actions or show a fallback message to the user
        }
      } catch (error) {
        // Handle the error silently without propagating it further
      }
    },
  }
};
</script>